import React, { useState } from 'react';
import styles from './Toggle.module.scss';
import { IToggle } from './Toggle.interface';
import classnames from 'classnames';

export const Toggle: React.FC<IToggle> = ({
  leftLabel,
  rightLabel,
  defaultActive = 'left',
  onToggle
}) => {
  const [activeOption, setActiveOption] = useState<'left' | 'right'>(
    defaultActive
  );

  const handleToggle = (option: 'left' | 'right'): void => {
    setActiveOption(option);
    onToggle(option);
  };

  return (
    <div className={styles['toggle-container']}>
      <button
        className={classnames(styles['toggle-button'], {
          [styles.active]: activeOption === 'left',
          [styles.inactive]: activeOption !== 'left'
        })}
        onClick={() => handleToggle('left')}
      >
        {leftLabel}
      </button>
      <button
        className={classnames(styles['toggle-button'], {
          [styles.active]: activeOption === 'right',
          [styles.inactive]: activeOption !== 'right'
        })}
        onClick={() => handleToggle('right')}
      >
        {rightLabel}
      </button>
    </div>
  );
};
